import { Typography } from '@mui/material';
import { Column, TableState, usePagination, useRowSelect, useSortBy, useTable } from 'react-table';
import { ContractApprovalWorkflowTableState } from 'shared/contexts/contract-approval-workflow-filter-context';
import { ContractReviewGridItem } from 'shared/types';
import { customerContractTableColumns } from './columns/contract-review-table-columns';

const defaultColumn: Partial<Column<ContractReviewGridItem>> = {
  Filter: () => null,
  Cell: ({ value = '' }) => <Typography variant='body2'>{value}</Typography>,
  disableFilters: true,
  width: 150,
  minWidth: 150,
  maxWidth: 150,
  align: 'inherit',
};

const getRowIdContract = (row: ContractReviewGridItem) => row.id;

export function useContractReviewTableInstance(
  data: ContractReviewGridItem[],
  totalCount: number,
  initialState: TableState<ContractApprovalWorkflowTableState>
) {
  return useTable<ContractReviewGridItem>(
    {
      columns: customerContractTableColumns,
      data,
      initialState,
      pageCount: totalCount,
      manualSortBy: true,
      manualPagination: true,
      manualFilters: true,
      defaultColumn,
      getRowIdContract,
      autoResetFilters: false,
      autoResetPage: false,
    },
    useSortBy,
    usePagination,
    useRowSelect
  );
}
